import { render, staticRenderFns } from "./ContactEditPriceRules.vue?vue&type=template&id=7a4b2547"
import script from "./ContactEditPriceRules.vue?vue&type=script&lang=ts"
export * from "./ContactEditPriceRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports